export default __webpack_public_path__ + "static/desktop_KV16-f7f9f956b60d5ea5ccd2d197e0cf4ede.mp4";